// Hands client-error telemetry the build's relay (VITE_RELAY_URL, else the cloud relay) and
// the app's saved-session rules as one side effect, before any app module loads.
// hooks.client.ts imports this FIRST; it depends only on leaf modules (guarded in its test).
import { configureClientTelemetry } from "@cyborg7/observability/web";
import { CLOUD_RELAY_HTTP_BASE } from "$lib/core/relay-config.js";
import { getSavedSession } from "$lib/core/saved-session.js";

configureClientTelemetry({ relayBase: CLOUD_RELAY_HTTP_BASE, session: getSavedSession });
